<template>
  <b-card
      title="مدیریت بودجه تبلیغات"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1 mr-auto"
                  variant="primary"
                  @click="showModal = true"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="اتریبیوشن"
                    label-for="Attribution"
                    class="d-inline-block full-width"
                >
                  <v-select
                      ref="Attribution"
                      v-model="filterOptions.AdsAttributionId"
                      dir="rtl"
                      :reduce="x => x.Id"
                      label="Title"
                      input-id="Attribution"
                      :clearable="true"
                      :options="attributions"
                      @open="getAttributions"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="مقدار"
                    label-for="Amount"
                >
                  <b-form-input
                      v-model="filterOptions.Amount"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(AdsAttributionId)="data">
            {{ (attributions.find(a => a.Id === data.value) || {}).Title }}
          </template>

          <template #cell(Amount)="data">
            {{ data.value | price }}
          </template>

          <template #cell(FromDate)="data">
            {{ data.value | date }}
          </template>

          <template #cell(ToDate)="data">
            {{ data.value | date }}
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <charge-form
        :show.sync="showModal"
        :item="editingItem"
        :attributions.sync="attributions"
        @update="update"
    />
  </b-card>
</template>

<script>
import chargeForm from "@/views/menu/campaign/charge/chargeForm.vue";
export default {
  name: 'Charges',
  components: { chargeForm },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      formLoading: false,
      showModal: false,
      attributions: [],
      filterOptions: {
        Amount: null,
        AdsAttributionId: null,
        FromDate: null,
        ToDate: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'AdsAttributionId',
          label: 'اتریبیوشن',
        },
        {
          key: 'Amount',
          label: 'مقدار',
        },
        {
          key: 'FromDate',
          label: 'از تاریخ',
        },
        {
          key: 'ToDate',
          label: 'تا تاریخ',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      editingItem: null
    }
  },
  watch: {
    showModal(val) {
      if (!val) this.editingItem = null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
    this.getAttributions()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.charges.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    getAttributions() {
      if (this.attributions.length) return
      this.$http.get(this.$api.attributions.getAll).then(response => {
        this.attributions = response.data
      }).catch(er => {
        console.log(er)
      })
    },
    edit(item) {
      this.editingItem = {
        Id: item.Id,
        AdsAttributionId: item.AdsAttributionId,
        Amount: item.Amount,
        FromDate: item.FromDate,
        ToDate: item.ToDate,
      }
      this.showModal = true
    },
    remove(id) {
      this.removeRow(this.$api.charges.remove, 'Id', id)
    },
  },
}
</script>